import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import type { Asset } from 'expo-media-library';
import { TouchableNativeFeedback, View } from 'react-native';
import { useMediaFilePicker } from '../functions/useMediaFilePicker.web';

export const MediaPickerScreen = wrapNavigatorScreen(
  ({
    photoOnly,
    max,
    onSelected,
  }: {
    photoOnly?: boolean;
    max?: number;
    onSelected: (medias: Asset[]) => void;
  }) => {
    const { onDismiss } = useMediaFilePicker({
      multiple: true,
      max,
      photoOnly,
      onSelected: async results => {
        const assets = results.map<Asset>((res, i) => ({
          id: `asset-${i}`,
          filename: res.filename ?? res.file.path.split('/').pop() ?? '',
          uri: res.uri,
          mediaType: res.type,
          width: res.type === 'photo' ? res.file.width : 0,
          height: res.type === 'photo' ? res.file.height : 0,
          creationTime: Date.now(),
          modificationTime: Date.now(),
          duration: 0,
        }));
        onSelected?.(assets);
      },
    });
    return (
      <TouchableNativeFeedback onPress={onDismiss}>
        <View
          css={`
            flex: 1;
          `}
        />
      </TouchableNativeFeedback>
    );
  },
);
